import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const removeFolderAPI = async (
  id,
  name,
  t,
  successText,
  setRefreshCapacity,
  onClose,
  reloadTable
) => {
  await axios({
    url: `/api/v2/drive/file/delete-folder`,
    method: "GET",
    params: {
      id: id,
      name: name
    }
  });
  successHandling(t, successText);
  setRefreshCapacity(true);
  reloadTable();
  onClose();
  return true;
};
